<!-- back to top button -->
<back-to-top />

@if (app.client.isS && app.isPlatformBrowser && !app.client.isCms) {
<div class="w-12 center wrap-m p-b"
     ngSkipHydration>
    @if (!modelsFiltered?.length) {
    <p class="p-t-10 p-b-6 fs-8 center">{{'There are no results matching your selection' | translate}}</p>
    } @else {
    <cdk-virtual-scroll-viewport [ngClass]="['listing-size-' + listingSize]"
                                 [style.--grid-columns]="listingSize"
                                 [style.--grid-column-gap.px]="2"
                                 [style.--grid-row-gap.px]="7"
                                 scrollWindow
                                 [columns]="listingSize"
                                 [height]="productHeight"
                                 [gtmTrackViewItemList]="gtmTrackViewItemList"
                                 [gtmTrackViewItemListOff]="client.isCms"
                                 (renderedOffsetChanged)="onRenderedOffsetChanged($event)"
                                 #virtualScrollRef>
        <!-- Show actual products -->
        <ng-container *cdkVirtualFor="let model of modelsFiltered; trackBy: trackByFn; templateCacheSize: 0">
            @let gridRowSpan = model.rowSpan | productRowSpan : model.colSpan : model.isLandscapeListingView;
            @let gridColumn = model.colSpan | productColSpan : model.rowSpan : model.isBanner : listingSize;
            <div class="flex flex-middle flex-justify-center"
                 [ngClass]="[
                            'colspan-' + gridColumn,
                            'rowspan-' + gridRowSpan
                        ]"
                 [gridColumn]="gridColumn"
                 [gridColumnPushLeft]="(model.data?.align_on_listing | optionLabel : 'align_on_listing') === 'left'  ? 1 : 0"
                 [gridColumnPushRight]="(model.data?.align_on_listing | optionLabel : 'align_on_listing') === 'right'  ? 1 : 0"
                 [gridRowSpan]="gridRowSpan"
                 [skeletonWrapper]="model.id"
                 [skeletonWrapperRootMargin]="'300px'">
                <ng-template #skeletonPlaceholderRef>
                    <skeleton-product class="w-12 h-100"
                                      [ratio]="model.isLandscapeListingView | aspectRatio : gridRowSpan : gridColumn"
                                      [banner]="!!model.isBanner" />
                </ng-template>
                <div class="h-100"
                     [ngClass]="[
                                'w-' + (model.colSpan | productWidth : model.rowSpan : model.isBanner : listingSize),
                                (gridColumn === 3 && listingSize === 3) || (gridColumn === 4 && listingSize === 4) ? 'w-12-s p-t-8-x p-t-8-l p-b-8-x p-b-8-l' : ''
                        ]">
                    @if (!!model.isBanner) {
                    <product-banner class="w-12 h-100"
                                    [model]="model"
                                    [priority]="$index < listingSize * 2" />
                    } @else {
                    <product class="w-12 h-100"
                             cy-listingProduct
                             [modelView]="modelView"
                             [model]="model"
                             [priority]="$index < listingSize * 2"
                             [searchTerm]="context === 'search' ? searchResult.term : undefined"
                             [sendTracking]="true"
                             [category]="category"
                             [listing]="listing"
                             [listingSize]="listingSize"
                             [listId]="listId"
                             [listName]="listName"
                             [listPosition]="$index" />
                    }
                </div>
            </div>
        </ng-container>
    </cdk-virtual-scroll-viewport>
    }
</div>
} @else {
<div class="w-12 center wrap-m p-b"
     (infiniteScroll)="listing?.increaseLimit()"
     [infinitScrollActive]="!!listing?.hasMore"
     cy-searchProductsListing
     cy-listingProductsGrid>
    <div [ngClass]="['listing-size-' + listingSize]"
         [grid]="listingSize"
         [gridColumnGap]="['2px','2px','4px','4px'][app.client.sizeId]"
         [gridRowGap]="7"
         [gtmTrackViewItemList]="gtmTrackViewItemList"
         [gtmTrackViewItemListOff]="client.isCms">
        <!-- Show actual products -->
        @for (model of listing?.models; track model.id) {
        @let gridRowSpan = model.rowSpan | productRowSpan : model.colSpan : model.isLandscapeListingView;
        @let gridColumn = model.colSpan | productColSpan : model.rowSpan : model.isBanner : listingSize;
        <div class="block"
             [ngClass]="[
                'colspan-' + gridColumn,
                'rowspan-' + gridRowSpan
            ]"
             [gridColumn]="gridColumn"
             [gridColumnPushLeft]="(model.data?.align_on_listing | optionLabel : 'align_on_listing') === 'left'  ? 1 : 0"
             [gridColumnPushRight]="(model.data?.align_on_listing | optionLabel : 'align_on_listing') === 'right'  ? 1 : 0"
             [gridRowSpan]="gridRowSpan"
             [skeletonWrapper]="model.id"
             [skeletonWrapperRootMargin]="'300px'">
            <ng-template #skeletonPlaceholderRef>
                <skeleton-product [ratio]="model.isLandscapeListingView | aspectRatio : gridRowSpan : gridColumn"
                                  [banner]="!!model.isBanner" />
            </ng-template>
            <div class="h-100"
                 [ngClass]="[
                    'w-' + (model.colSpan | productWidth : model.rowSpan : model.isBanner : listingSize),
                    (gridColumn === 3 && listingSize === 3) || (gridColumn === 4 && listingSize === 4) ? 'w-12-s p-t-8-x p-t-8-l p-b-8-x p-b-8-l' : ''
            ]">
                @if (!!model.isBanner) {
                <product-banner class="w-12 h-100"
                                [model]="model"
                                [priority]="$index < listingSize * 2" />
                } @else {
                <product class="w-12 h-100"
                         [modelView]="modelView"
                         [model]="model"
                         [priority]="$index < listingSize * 2"
                         [searchTerm]="context === 'search' ? searchResult?.term : undefined"
                         [sendTracking]="true"
                         [category]="category"
                         [listing]="listing"
                         [listId]="listId"
                         [listName]="listName"
                         [listPosition]="$index"
                         [listingSize]="listingSize"
                         cy-listingProduct />
                }
            </div>
        </div>
        } @empty {
        @for (item of skeletonArray; track $index) {
        <div class="block">
            <skeleton-product />
        </div>
        } @empty {
        <p class="p-t-10 p-b-6 fs-8 center"
           [gridColumn]="listingSize">{{'There are no results matching your selection' | translate}}</p>
        }
        }
    </div>
</div>
}